import React from "react";

function TitleMain({ children }) {
  return <h1>{children}</h1>;
}

export default TitleMain;
